<template>
  <OverlayBadge :value="props.value" :severity="props.severity" size="small">
    <slot>
      <i v-if="icon" :class="icon" :style="{ fontSize: `${iconSize}rem` }" />
    </slot>
  </OverlayBadge>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import type { MOPOverlayBadgeProps } from './types'

export default defineComponent({
  name: 'MOPOverlayBadge',
  inheritAttrs: false
})
</script>

<script setup lang="ts">
import OverlayBadge from 'primevue/overlaybadge'

const props = withDefaults(defineProps<MOPOverlayBadgeProps>(), {
  value: undefined,
  severity: null,
  icon: undefined,
  iconSize: 2,
  size: 'normal'
})
</script>
